export enum ClientsEnum {
  grupoGomez = 1,
  saona = 134,
  lassal = 986,
  delPoble = 1117,
}
